/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_8_QInputs */

const en_mk_faq_8_q = /** @type {(inputs: Mk_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is our data used to train AI models?`)
};

const id_mk_faq_8_q = /** @type {(inputs: Mk_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah data kami dipakai untuk melatih model AI?`)
};

/**
* | output |
* | --- |
* | "Is our data used to train AI models?" |
*
* @param {Mk_Faq_8_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_8_q = /** @type {((inputs?: Mk_Faq_8_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_8_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_8_q(inputs)
	return en_mk_faq_8_q(inputs)
});